import { authGet } from "@api";

import { SCMConfigListResponse } from "@pages/settings/types";

export const getSCMConfigs = (
  parentOrgId: number
): Promise<SCMConfigListResponse> => {
  const path = `/api/agent/organizations/${parentOrgId}/scm_configs`;
  return authGet<SCMConfigListResponse>(path);
};
